const RX_MARKUP = /<([^<>])+(\/)?>/g;
const SPACES = /\s+/g;
const SPACE = " ";

export default function stripMarkup(stringWithMarkup: string) {
    return stringWithMarkup
        .replace(RX_MARKUP, SPACE)
        .replace(SPACES, SPACE)
        .trim();
}
